module.exports = __webpack_public_path__ + "static/media/20180524-LCS-031-17.39202e4f.jpg";